import React from 'react';

// Generic failure message (FR-015): no technical detail, just a way forward.
export default function ErrorPanel({t, onRetry, onSkip, busy}) {
    return (
        <div className="di-card di-error">
            <p className="di-error__message">{t.error_message}</p>
            <div className="di-error__actions">
                <button type="button" className="di-cta di-cta--inline" onClick={onRetry} disabled={busy}>
                    {t.try_again}
                </button>
                <button type="button" className="di-link" onClick={onSkip} disabled={busy}>{t.skip}</button>
            </div>
        </div>
    );
}
